import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { subscriptionPlanApi, paymentApi } from '../services/api';
import { PaymentForm } from '../components/PaymentForm';
import { Check } from 'iconoir-react';
import '../styles/register.css';
import '../styles/payment.css';

export const UpgradePlanPage: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { planId, billingPeriod } = location.state || {};

  const [selectedPlan, setSelectedPlan] = useState<any>(null);
  const [selectedBillingPeriod, setSelectedBillingPeriod] = useState<'monthly' | 'yearly'>(billingPeriod || 'monthly');
  const [loading, setLoading] = useState(true);
  const [paymentProcessing, setPaymentProcessing] = useState(false);

  useEffect(() => {
    if (!planId) {
      navigate('/account');
      return;
    }

    loadPlan();
  }, [planId]);

  const loadPlan = async () => {
    try {
      const response = await subscriptionPlanApi.getById(planId);
      setSelectedPlan(response.data.plan);
    } catch (error) {
      console.error('Erreur lors du chargement du plan:', error);
      navigate('/account');
    } finally {
      setLoading(false);
    }
  };

  const handlePaymentSuccess = () => {
    navigate('/dashboard');
  };

  const handlePaymentError = (error: string) => {
    alert('Erreur lors du paiement: ' + error);
    setPaymentProcessing(false);
  };

  if (loading || !selectedPlan) {
    return (
      <div className="register-page">
        <div className="register-container">
          <div className="loading">Chargement...</div>
        </div>
      </div>
    );
  }

  const rawAmount = selectedBillingPeriod === 'monthly' ? selectedPlan.price_monthly : selectedPlan.price_yearly;
  const amount = typeof rawAmount === 'number' ? rawAmount : parseFloat(rawAmount || '0');

  return (
    <div className="register-page">
      <div className="register-container">
        <div className="register-header">
          <img src="/assets/ventilio.png" alt="Ventilio" className="register-logo" />
          <h1>Mise à niveau de votre plan</h1>
        </div>

        <div className="step-content">
          <h2>Paiement - {selectedPlan.display_name}</h2>
          
          <div className="plan-summary">
            <h3>Récapitulatif</h3>
            <div className="summary-item">
              <span>Plan sélectionné:</span>
              <strong>{selectedPlan.display_name}</strong>
            </div>
            <div className="summary-item">
              <span>Période de facturation:</span>
              <strong>{selectedBillingPeriod === 'monthly' ? 'Mensuel' : 'Annuel'}</strong>
            </div>
            <div className="summary-item total">
              <span>Total à payer:</span>
              <strong>{amount.toFixed(2)}€</strong>
            </div>
          </div>

          <div className="payment-note">
            <p>Le paiement est sécurisé et traité par Stancer</p>
          </div>

          <PaymentForm
            amount={amount}
            currency="EUR"
            description={`Abonnement ${selectedPlan.display_name} - ${selectedBillingPeriod === 'monthly' ? 'Mensuel' : 'Annuel'}`}
            planId={selectedPlan.id}
            billingPeriod={selectedBillingPeriod}
            onPaymentSuccess={handlePaymentSuccess}
            onPaymentError={handlePaymentError}
          />

          <div className="step-actions">
            <button 
              type="button" 
              className="btn btn-secondary"
              onClick={() => navigate('/account')}
              disabled={paymentProcessing}
            >
              Annuler
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
